<script>
    import Form from 'form-backend-validation';
    import ClientLayout from '@/Layouts/Client';
    import { step } from '@/Layouts/ClientUtils';
    import PrimaryButton from '@/components/client/Buttons/PrimaryButton';
    import InputField from '@/components/client/Inputs/Input';

    export default {
        layout: ClientLayout,
        props: ['company'],
        components: { PrimaryButton, InputField },

        data () {
            return {
                step: step,
                form: this.$inertia.form({
                    email_address: null,
                    street_address: null,
                    phone_number: null,
                    zip_code: null,
                    city: null,
                    url: null,
                    invoice_email: null,
                    // Company user
                    contact_email: null,
                    contact_firstname: null,
                    contact_lastname: null,
                }),
            }
        },

        created () {
            this.step.name = 'contact';

            // const company = this.$page.props.currentUser.company;
            const company = this.company;
            const companyUser = this.$page.props.currentUser;

            this.form.email_address = company.email_address;
            this.form.street_address = company.street_address;
            this.form.phone_number = company.phone_number;
            this.form.zip_code = company.zip_code;
            this.form.city = company.city;
            this.form.url = company.url;
            this.form.invoice_email = company.invoice_email;
            this.form.contact_email = companyUser.email;
            this.form.contact_firstname = companyUser.first_name;
            this.form.contact_lastname = companyUser.last_name;
        },

        methods: {
            async save() {
                const success = await this.updateCompany().catch(() => {
                    //
                });

                if (!this.step.isCompleted() && success) {
                    this.step.complete();
                }
            },

            async updateCompany () {
                if (this.form.processing) {
                    return;
                }

                this.form.processing = true;

                return new Promise((resolve, reject) => {
                    this.form.put(`/kund/${this.company.slug}/foretag`, {
                        onSuccess: () => {
                            this.$moshaToast('Dina ändringar har sparats!', {
                                type: 'success',
                                timeout: 2000,
                            });

                            resolve(true);
                        },

                        onError: () => {
                            reject(false);
                        }
                    });
                });
            },
        }
    }
</script>

<template>
    <div>
        <div class="flex flex-col md:flex-row md:h-12 items-center mb-6 md:mb-2">
            <h2 class="text-md md:text-2xl text-red font-avertaBold">
                <span class="uppercase">Mina sidor Företag</span>
                / <span class="font-averta">Kontaktuppgifter</span>
            </h2>

            <primary-button
                :loading="form.processing"
                @click="save"
                class="w-full md:w-auto mt-5 md:mt-0 ml-auto">Spara</primary-button>
        </div>

        <div class="bg-white rounded-md shadow-sm p-6">
            <strong>OBS!</strong> De kontaktuppgifter som du anger här är ej publika och visas alltså inte online! Vi använder dessa uppgifter när vi behöver komma i kontakt med er. (De uppgifter du vill ska vara synliga för våra medlemmar online ska du lägga du in när du skapar din Företagssida.)

            <form @submit.prevent="updateCompany" @keydown="form.errors[$event.target.name] = null" class="mt-8">
                <div class="flex flex-col md:flex-row md:-mx-2">
                    <div class="md:w-1/3 md:mx-2">
                        <input-field
                            v-model="form.contact_firstname"
                            name="contact_firstname"
                            label="Förnamn kontaktperson"
                            placeholder="*Förnamn kontaktperson"
                            :error="form.errors.contact_firstname" />
                    </div>

                    <div class="mt-2 md:mt-0 md:w-1/3 md:mx-2">
                        <input-field
                            v-model="form.contact_lastname"
                            name="contact_lastname"
                            label="Efternamn kontaktperson"
                            placeholder="*Efternamn kontaktperson"
                            :error="form.errors.contact_lastname" />
                    </div>

                    <div class="mt-2 md:mt-0 md:w-1/3 md:mx-2">
                        <input-field
                            v-model="form.contact_email"
                            name="contact_person"
                            label="E-post till kontaktperson"
                            placeholder="*E-post kontaktperson"
                            :error="form.errors.contact_email" />
                    </div>
                </div>

                <div class="flex flex-col md:flex-row mt-4 md:-mx-2">
                    <div class="md:w-1/2 md:mx-2">
                        <input-field
                            v-model="form.street_address"
                            name="street_address"
                            label="Faktura-/besöksadress"
                            placeholder="*Gatuadress"
                            :error="form.errors.street_address" />
                    </div>

                    <div class="md:w-1/2 md:mx-2 mt-2 md:mt-0">
                        <input-field
                            v-model="form.invoice_email"
                            name="invoice_email"
                            label="E-post för faktura"
                            placeholder="E-post faktura"
                            :error="form.errors.invoice_email" />
                    </div>
                </div>

                <div class="flex flex-col md:flex-row mt-4 md:-mx-2">
                    <div class="md:w-1/2 md:mx-2">
                        <div class="flex flex-col md:flex-row md:-mx-2">
                            <div class="md:w-1/2 md:mx-2">
                                <input-field
                                    v-model="form.zip_code"
                                    name="zip_code"
                                    label="Postnummer"
                                    placeholder="*Postnummer"
                                    :error="form.errors.zip_code" />
                            </div>
                            <div class="md:w-1/2 md:mx-2 mt-2 md:mt-0">
                                <input-field
                                    v-model="form.city"
                                    name="city"
                                    label="Ort"
                                    placeholder="*Ort"
                                    :error="form.errors.city" />
                            </div>
                        </div>
                    </div>

                    <div class="md:w-1/2 md:mx-2 mt-2 md:mt-0">
                        <input-field
                            v-model="form.phone_number"
                            name="phone_number"
                            label="Mobilnummer"
                            placeholder="*Mobilnummer"
                            :error="form.errors.phone_number" />
                    </div>
                </div>

                <primary-button
                    :loading="form.processing"
                    @click="save"
                    class="w-full md:hidden mt-5">Spara</primary-button>
            </form>
        </div>
    </div>
</template>
